import type { Notification } from '@maru44/huntre-utils/src/models/notification'
import { type UsePaginatedCollectionOptions, usePaginatedCollection } from '../usePaginatedCollection'

export const useNotifications = (clientId: string, clientMemberId: string, options: UsePaginatedCollectionOptions = {}) => {
  const collectionPath = `clients/${clientId}/clientMembers/${clientMemberId}/notifications`

  const listNotifications = usePaginatedCollection<Notification>(collectionPath, {
    ...options,
    disabled: !clientId || !clientMemberId || options.disabled,
  })

  return {
    listNotifications,
  }
}
